export default __webpack_public_path__ + "static/media/icon_search-anchor-black-hover.828e5ec7.svg";